"use client";

import { ChevronLeft, ChevronRight } from "lucide-react";
import React from "react";

interface PaginationProps {
  currentPage: number;
  totalRecords: number;
  perPage: number;
  goToPage: (page: number) => void;
  changePerPage: (perPage: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalRecords,
  perPage,
  goToPage,
  changePerPage,
}) => {
  const totalPages = Math.ceil(totalRecords / perPage);

  const start = (currentPage - 1) * perPage + 1;
  const end = Math.min(start + perPage - 1, totalRecords);

  return (
    <div className="padding-x my-6 shadow-[0px_1px_11.7px_1px_#B9B9B914] rounded-xl flex justify-center items-center gap-4 py-4">
      <p className="text-grey-600">
        {start}-{end} of {totalRecords} items
      </p>

      <button
        disabled={currentPage <= 1}
        onClick={() => goToPage(currentPage - 1)}
        className="px-4 py-1 inline-flex gap-1 text-gray-500 border border-gray-300 rounded-full cursor-pointer items-center justify-center disabled:opacity-40"
      >
        <ChevronLeft size={24} />
      </button>

      {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
        <div
          key={page}
          onClick={() => goToPage(page)}
          className={`px-4 py-1 cursor-pointer rounded-full ${
            currentPage === page
              ? "text-gray-500 border border-gray-300"
              : "text-grey-800"
          }`}
        >
          {page}
        </div>
      ))}

      <button
        disabled={currentPage >= totalPages}
        onClick={() => goToPage(currentPage + 1)}
        className="px-4 py-1 inline-flex gap-1 text-gray-500 border border-gray-300 rounded-full cursor-pointer items-center justify-center disabled:opacity-40"
      >
        <ChevronRight size={24} />
      </button>

      <div className="px-2 py-1 inline-flex gap-1 text-gray-500 border border-gray-300 rounded-full items-center justify-center">
        <select
          value={perPage}
          onChange={(e) => changePerPage(Number(e.target.value))}
          className="bg-transparent outline-none cursor-pointer"
        >
          {[1, 5, 10, 20, 50].map((n) => (
            <option key={n} value={n} className="text-black">
              {n}
            </option>
          ))}
        </select>
      </div>

      <p className="text-grey-600">Items per page</p>
    </div>
  );
};

export default Pagination;
